import React, { useEffect } from "react";
import { SkinInterface } from "../../../../store/roblox/skinsSlice";

import {Button, Form, Input, Radio} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import ThumbnailGenerator from "./_ThumbnailGenerator";

interface propsInterface {
  params?: SkinInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const [skinPreview, setSkinPreview] = React.useState<string | undefined>(params?.thumbnail_url);
  const typeIdValue   = Form.useWatch('type_id', form);

  useEffect(() => {
    form.resetFields();
    setSkinPreview(params?.thumbnail_url);
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='target_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={skinPreview} />
        <FileDropzone name='texture' label='Texture' preview={params?.texture_url} />
        <FileDropzone name='mask' label='Mask' preview={params?.mask_url} />
      </div>

      {
        typeIdValue !== 4 &&
          <ThumbnailGenerator
            form={form}
            imgUrl={params?.texture_url}
            setSkinPreview={setSkinPreview}
          />
      }

      <Form.Item label="Type" name='type_id'>
        <Radio.Group>
          <Radio value={0}>Pants</Radio>
          <Radio value={1}>Shirt</Radio>
          <Radio value={2}>T-Shirt</Radio>
          <Radio value={3}>Post</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
